// ESM-Huelle um lib/scripts/pos/CLS_CDataExport.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.
	function CDataExport() {
	    var path = "var/db/export/";

	    this.Trans = new CBonTransaction();
	}



	CDataExport.prototype.generateandExportReports = function(me, i, start,end) {
	    if (!POS.SQLiteCon) {
		var myDir= fs.getMyDir();
		 var db  = new CSQlite(myDir + "/var/db/POS.db");
		POS.SQLiteCon = db; 
	   } else {
	        db = POS.SQLiteCon;
	    }
	    debugger;
	    POS.hourGlass.show("Generiere Reports!");
	    log.add(2, " Info ", " Generiere Reports!");
	    var r = new CReports(db);
	    $.when(r.createReports(null, null, start,end)).then(function() {


	        $.when(me.exportReports(me, 0)).then(function() {
	            // run last pos-push
	            POS.runPOSPush();
	            POS.hourGlass.hide();
	        });
	    });

	}

	CDataExport.prototype.exportReports = function(me, i, defret) {
	    //	this.Reports = ["DAILY", "PRODSELLINGS"];
	    POS.hourGlass.show("Generiere Reports!");
	    var me = POS.DataExport;
	    if (!defret) defret = jQuery.Deferred();
	    //POS.Reports.sqlite3 = require('sqlite3');
	    //var reports = new POS.Reports.sqlite3.Database("var/db/POSysseus_Reports.db"); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);
		 var myDir= fs.getMyDir();
 		var reports = new CSQlite(myDir + "var/db/POSysseus_Reports.db")
	    log.add(2, " Info ", " Exportiere Reports!");
	    if (!i) i = 0;
	    if (i > POS.Reports.Reports.length) {
	        defret.resolve();
	        //POS.hourGlass.hide();
	        return 1;
	    }
	    debugger;
	    var sql;
	    switch (POS.Reports.Reports[i]) {
	        case "DAILY":
	        case "PRODSELLINGS":
	            // NICHT mehr nach MySQL (Nutzer-Entscheide 29.9.2026). Beide
	            // Tabellen rechnet allein createReports.sh am Nodeserver aus
	            // der POS.db-Kopie. Der Export hier loeschte ab max(DAY) - und
	            // bei Zeitlimit/leerer Antwort (sendQuery ruft dann
	            // callback(null) OHNE Fehler) ab heute-32 Tage - und schrieb
	            // die lokalen Zeilen, bei DAILY u.U. Nullen aus
	            // insertEmptyDays. Die lokalen Berichte in POSysseus_Reports.db
	            // bleiben, nur der Export entfaellt.
	            me.exportReports(me, i + 1, defret);
	            return defret.promise();
	        default:
	            defret.resolve();
	            return;

	    }
	    $.when(me.exportReportToMySQL(me, POS.Reports.Reports[i], sql, reports, false)).then(function() {
	        me.exportReports(me, i + 1, defret);
	        return;
	    });
	    return defret.promise();
	};



	CDataExport.prototype.insertProdSellSQL = function(i, rows) {
	    if (!POS.MasterID || POS.MasterID == undefined) {
	        POS.MasterID = POS.POSId;
	    }
	    return "INSERT IGNORE INTO PRODSELLINGS(POS_ID, DAY, Type, ProdName, Delivered, Expirated, Sold,  \
SellPrice, SellUnitPrice, BuyPrice, BuyUnitPrice, GroupName, Button,Master_ID)VALUES(" +
	        rows[i].POS_ID + ", '" + rows[i].DAY + "', '" + rows[i].Type + "', '" + rows[i].ProdName + "', " +
	        (rows[i].Delivered || 0) + ", " + (rows[i].Expirated || 0) + ", " +
	        rows[i].Sold + ", " + (rows[i].SellPrice || 0) + ", " + rows[i].SellUnitPrice +
	        ", " + (rows[i].BuyPrice || 0) + ", " + (rows[i].BuyUnitPrice || 0) + ", '" + rows[i].GroupName + "', '" +
	        rows[i].Button + "'," + POS.MasterID + ");";
	}

	CDataExport.prototype.insertDailySQL = function(i, rows) {
	    return "INSERT  IGNORE INTO DAILY (POS_ID,POSIDMaster,UName,DAY,Turnover,ProductSum,Rebates,\
			CreditVouchers,VoucherPayments,PrepaidCard,CashCardPayments,CreditCardPayments,CashPayments,PersonalPurchase,CashBalance,TurnOverREG,TAXNormal \
			,TAXErm1,TAXErm2,TAXNull,TAXBes,VoucherPurchase,PurchaseCount,Claim,Cash,AM_PM) VALUES \
			(" + rows[i].POSID + "," + rows[i].POSIDMaster + ",'" + rows[i].UName + "','" + rows[i].DAY + "'," + rows[i].Turnover + "," + rows[i].ProductSum + "," + rows[i].Rebates + "," + rows[i].CreditVouchers + "," +
	        rows[i].VoucherPayments + "," + rows[i].PrepaidCard + "," + rows[i].CashCardPayments + "," + rows[i].CreditCardPayments + "," + rows[i].CashPayments +
	        "," + rows[i].PersonalPurchase + "," + rows[i].CashBalance + "," + rows[i].TurnOverREG + "," + rows[i].TAXNormal +
	        "," + rows[i].TAXErm1 + "," + rows[i].TAXErm2 + "," + rows[i].TAXNull + "," + rows[i].TAXBes + "," + rows[i].VoucherPurchase + "," + rows[i].PurchaseCount + "," + rows[i].Claim + "," + rows[i].Cash + ",'" + rows[i].AM_PM + "')";
	}

  CDataExport.prototype.exportReportToMySQL = function(me, tablename, exportsql, reports, stopTunnel) {


            var defret = jQuery.Deferred();

                var connection = new CRunClient();

                log.add(2, " Info ", " Transferiere Reports!");
                var def = jQuery.Deferred();

                    var sql = "SELECT max(DAY)as maxday from " + tablename + " where POS_ID = " + POS.POSId;
                var callback = function(rows, err) {
                        if (err) {
                            log.add(1, " MySQLError ", err);
							return;
                        } else {
                            if (rows == null || !rows[0] || rows[0].maxday == null) {
                                //  var maxday = 0;
                                var now = new Date();
                                var maxday = DateToString(new Date(now.getTime() - 4 * 8 * 24 * 60 * 60 * 1000)); //4 Wochen zurpück
                            } else {
                                maxday = rows[0].maxday;
                            }
                            //this.sqlite3 = require('sqlite3');
                            sql = "SELECT * from " + tablename + " where DAY >= '" + maxday + "'";
				 var myDir= fs.getMyDir();
                            var reportsdb = new CSQlite(myDir + "var/db/POSysseus_Reports.db"); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);
                        $.when(reportsdb.execute(sql)).then(function(rows) {

                                var iterator = function it(i) {
                                    if (i < rows.length) {
                                        //console.log(row);
										connection.sendQuery(exportsql(i, rows), function(result,err) {
                                            if (err) {
                                                log.add(1, "Error POS_Reports ", "Error in INSERT : " + err, null);
											}
                                                iterator(i + 1);
                                        },"POSysseus_Reports");
                                    } else {
                                        def.resolve();
                                        //reportsdb.close();
                                    }
                                }
                                sql = "DELETE from " + tablename + " where POS_ID=" + POS.POSId + " and DAY >= '" + maxday + "'";
                                connection.sendQuery(sql, function(result,err) {
						
                                    if (err) {
                                        log.add(1, "Error POS_Reports ", "Error in DELETE : " + err, null);
                                    }
                                iterator(0);
                                },"POSysseus_Reports" );
                                $.when(def).done(function() {
                                    defret.resolve();
                                    log.add(2, "Info ", "Transferiere " + tablename + " Reports Ende!");
                                });
							}
							,function(){
                                    log.add(1, "Error POS_Reports ", " Error : " + err, null);
                                    return;
							}); //fail
						
						}
				}
                connection.sendQuery(sql, callback, "POSysseus_Reports");
				return defret.promise();
        }



	CDataExport.prototype.insertIntoReportsDB = function(me, sql, tablename) { //vom Slave aufgerufen

	    var def = jQuery.Deferred();
	    var sql3 = require('sqlite3');
	    var sqls = sql.split(";");

	    var reportsdb = new sql3.Database("var/db/POSysseus_Reports.db"); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);

	    var iterator = function it(i) {
	        if (i < sqls.length) {
	            reportsdb.run(sqls[i], function(err, rows) {
	                if (err) {
	                    log.add(1, "Error POS_Reports insert Slave", " Error : " + err, null);
	                    iterator(i + 1);
	                    return;
	                }
	                iterator(i + 1);
	            });
	        } else {
	            reportsdb.close();
	            def.resolve();
	        }
	    }
	    iterator(0);
	    return def.promise();
	}


	CDataExport.prototype.removeDuplicatesfromMySQL = function(me, tablename, firstday, lastday, posid) {

	    var exportsql = me.insertProdSellSQL;
	    var defret = jQuery.Deferred();
	    $.when(me.createTunnelToMySQL()).done(function() {
	        log.add(2, " Info ", " Remove Duplicates!");
	        //$.when(r.createViews(db)).then(function () {
	        //r.ProdSellings(1459528420, 9999999999999999, POS);
	        var def = jQuery.Deferred();
	        var mysql = require('mysql');
	        var connection = mysql.createConnection({
	            host: 'localhost',
	            port: 3340,
	            user: 'root',
	            password: 'du$e8reP',
	            database: 'POSysseus_Reports',
	            insecureAuth: true
	        });
	        connection.connect(function(err) {
	            if (err) {
	                log.add(1, " MySQLError ", " Connection Error : " + err.stack);
	                return;
	            }
	            console.log('connected as id ' + connection.threadId);

	            var sql = "SELECT * from " + tablename + " where POS_ID=" + posid + " and DAY>='" + firstday + "' and DAY<='" + lastday + "' group by DAY,Type,ProdName";
	            connection.query(sql, function(err, rows, fields) {
	                //var reportsdb = new this.sqlite3.Database("var/db/POSysseus_Reports.db"); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);
	                //reportsdb.all(sql, function(err, rows) {

	                if (err) {
	                    log.add(1, " MySQLError ", err);
	                } else {
	                    /*  this.sqlite3 = require('sqlite3');
	                      sql = "SELECT * from " + tablename + " where DAY >= " + maxday;
	                      var reportsdb = new this.sqlite3.Database("var/db/POSysseus_Reports.db"); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);*/
	                    sql = "DELETE from " + tablename + " where POS_ID=" + posid + " and DAY>='" + firstday + "' and DAY<='" + lastday + "'";
	                    connection.query(sql, function(err, rows1, fields) {
	                        if (err) {
	                            log.add(1, "Error POS_Reports ", " Error : " + err, null);
	                            return;
	                        }
	                        var iterator = function it(i) {
	                            if (i < rows.length) {
	                                //console.log(row);
	                                connection.query(exportsql(i, rows), function(err, result) {
	                                    if (err) {
	                                        log.add(1, "Error POS_Reports ", "Error in INSERT : " + err, null);
	                                    }
	                                    iterator(i + 1);
	                                });
	                            } else {
	                                def.resolve();
	                                //	                                reportsdb.close();
	                            }
	                        }
	                        iterator(0);
	                        $.when(def).done(function() {
	                            me.stopTunnelToMySQL();
	                            connection.end();
	                            defret.resolve();
	                            log.add(2, "Info ", "Generiere " + tablename + " Reports Ende!");
	                        });
	                    });
	                };
	            });


	        });

	    }).fail(function() { //Tunnel noch nicht gestartet
	        log.add(1, " Reports MySQLError ", " ReportsConnection Error: No connection");
	        defret.resolve();
	        return;
	    });
	    return defret.promise();
	}

export { CDataExport };
